// extracted by mini-css-extract-plugin
export default {"linked-button":"LinkedButton_linked-button_V1GWL"};